<template>
	<TooltipComponent
		class="edit-info-wrapper"
		:tooltip
		direction="top"
	>
		<template #showFromOutside>
			<div class="edit-info-container">
				<span><i class="far fa-clock"></i> {{ infoText }}</span>
				<span v-if="editorName">by {{ editorName }}</span>
			</div>
		</template>
	</TooltipComponent>
</template>
<script lang="ts">
	export interface IEditInfoProps {
		editableObject: IHasEditor | IHasTimeStamp;
	}
</script>

<script setup lang="ts">
	import { computed } from 'vue';
	import { IHasEditor } from '@core/_interfaces/IHasEditor';
	import { IHasTimeStamp } from '@core/_interfaces/IHasTimeStamp';

	import TooltipComponent from '@core/components/TooltipComponent.vue';

	const { editableObject } = defineProps<IEditInfoProps>();

	const editorName = computed(() => (editableObject as IHasEditor).editedByName);

	const creatorName = computed(() => (editableObject as IHasEditor).createdByName);

	const infoText = computed(() => `Modified at ${editableObject.lastModifiedAt?.toLocaleString() ?? 'Unknown Time'}`);

	const tooltip = computed(() => {
		let tooltipText = `Created at ${editableObject.createdAt?.toLocaleString() ?? 'Unknown Time'}`;

		if (creatorName.value) {
			tooltipText += ` by ${creatorName.value}`;
		}

		return [tooltipText];
	});
</script>

<style scoped>
	.edit-info-wrapper {
		font-size: 0.9rem;
		color: var(--third-color);
	}

	.edit-info-container {
		display: flex;
		flex-direction: column;
		text-align: right;
	}
</style>
